import * as React from 'react';
import styled from 'styled-components';
import { rem, darken } from 'polished';
import { Button } from '../../Zemplin/General/Button';
import { FlexRowCenterVertical, IconImg } from '../../..';
import * as favoriteSrc from '../../../../assets/dsi/favorite.svg';
import * as compareSrc from '../../../../assets/dsi/compare.svg';

function FavoriteCompare() {
  return (
    <>
      <Wrapper>
        <Item>
          <StyledIconImg
            cursor={'pointer'}
            src={compareSrc.toString()}
            alt="Porovnať produkt."
            marginRight={false}
          />
        </Item>
        <Item>
          <StyledIconImg
            cursor={'pointer'}
            src={favoriteSrc.toString()}
            alt="Pridať do obľúbených."
            marginRight={false}
          />
        </Item>
      </Wrapper>
    </>
  );
}

const Wrapper = styled(FlexRowCenterVertical)``;

const Item = styled(Button)`
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border: 1px solid #cccccc;
  border-radius: 4px;
  padding: ${rem(8)} ${rem(16)};
  margin-right: ${rem(8)};
  &:last-child {
    margin-right: 0;
  }
`;

const StyledIconImg = styled(IconImg)`
  max-width: ${rem(56)};
`;

export { FavoriteCompare };
